// extracted by mini-css-extract-plugin
module.exports = {"player":"audio-player_player__kt_15","content":"audio-player_content__40OWH"};